import React, { useEffect } from 'react';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { Add, FileCopySharp } from '@material-ui/icons';
import { ConstantPermissions } from 'contexts/useConstant';
import ReactTable from 'components/ReactTable/ReactTable';
import { wsFindBy } from 'services/WService';
import { useNavigate } from 'react-router-dom';
import { Toasty, useToasty } from 'hooks/Toasty';
import { WithApp } from 'contexts/appContext';
import { useState } from 'react';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import GridContainer from 'components/Grid/GridContainer';
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardIcon from 'components/Card/CardIcon';
import CardBody from 'components/Card/CardBody';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 100 },
  { Header: 'Fecha Operación', accessor: 'TaxDate', width: 160, },
  // { Header: 'Zona', accessor: 'base_zone_description', width: 90 },
  { Header: 'Cuenta', accessor: 'account', width: 170 },
  { Header: 'Descripción operación', accessor: 'description_operation', width: 230 },
  { Header: 'Monto', accessor: 'amount', width: 150 },
  { Header: 'Operación', accessor: 'operation', width: 120 },
  { Header: 'Referencia', accessor: 'ref2' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function StatementBankList(props) {
  const classes = useStyles();
  const navigate = useNavigate();
  const [deposits, setDeposits] = useState([]);
  const [notify, showNotify] = useToasty();
  const [model, setOpen] = useModal();

  const [filter, setFilter] = useState({});
  const [alert, setAlert] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);

  async function listDocOperation() {
    setDataLoading(true);
    let res = await wsFindBy('pymt/deposit/index-operation', filter);
    setDataLoading(false);
    if (res.success) {
      setDeposits(res.data);
    }
  }

  useEffect(() => {
    if (Object.keys(filter).length === 0) {
      return;
    }
    listDocOperation();
  }, [filter]);

  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={() => listDocOperation(filter)}
        />
      ) : undefined}
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.PYMT_DEPOSITS_STORE}
              component={
                <CardIcon color="primary">
                  <FileCopySharp style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de extractos bancarios {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <FilterCustom dateRange diffRange={7} getFilter={setFilter} zone />
            <ReactTable
              defaultWidth={1900}
              columns={columns}
              formatDate="DD-MM-YYYY"
              data={deposits.map((item, i) => {
                return {
                  ...item,
                  num: (
                    <div className="actions-right">
                      {i + 1}
                    </div>
                  ),
                  TaxDate: item.TaxDate,
                  base_zone_description: item.zone?.description,
                  account: item.account,
                  description_operation: item.description_operation,
                  amount: item.amount,
                  operation: item.operation,
                  ref2: item.ref2,
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

export default WithApp(StatementBankList);
